import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { setIsMobile } from "../../../redux/actions/action";

const PasswordResetSuccess = () => {
  const dispatch = useDispatch();
  const isMobile = useSelector((state) => state.getGlobalReducer.isMobile);

  useEffect(() => {
    const checkMobile = () => {
      const isMobileDevice = window.innerWidth <= 768;
      dispatch(setIsMobile(isMobileDevice));
    };
    checkMobile();

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [dispatch]);

  return (
    <>
      <div>
        <div className="text-center my-3">
          <img src="/img/logo@2x.png" className="img-fluid" />
        </div>
        <div className="background-screen">
          <div className="d-grid justify-content-center align-items-center h-100">
            <Card style={{ width: "324px", padding: "5%" }}>
              <Card.Body>
                <div>
                  <h3 className="text-center mb-4 font-weight-bold">
                    Success!
                  </h3>
                  <p>Your password has been reset</p>
                  {isMobile && (
                    <div className="text-center">
                      <a href="eqwellmobile://login">
                        <button className="btn-login btn-lg" type="button">
                          Login with App
                        </button>
                      </a>
                      <p style={{ margin: 0, paddingTop: "16px" }}>
                        &#8212; OR &#8212;
                      </p>
                    </div>
                  )}
                </div>
              </Card.Body>
              <p className="d-flex m-auto mb-4">
                <Link to="/login" className="text-decoration-none">
                  Back to login
                </Link>
              </p>{" "}
            </Card>
            <div>
              <p className="text-center text-white">
                {" "}
                &copy; 2025 EQWELL ~ All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
export default PasswordResetSuccess;
